import React, { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import moment from 'moment'
import { connect } from 'react-redux'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import {
  dispatchView,
  reportView,
  excelHeader,
  memoSummaryHeader,
  PDFHeaderColumnsForStationWise,
  PDFHeaderColumnsForVehicleWise,
  StationWiseMemoCol,
  StationWiseMemoColumn,
  StationWiseSummaryColumn,
  VehicleWiseSummaryColumn,
} from './constant'
import {
  getDispatchRegisterReportFilter,
  GetDispatchRegistorMemoTableData,
} from '../../../../store/reports/reports_action'
import { updateAlertError } from '../../../../store/common/common_action'
import { removeDuplicatesFromArray } from '../../../common/helper'
import { GetRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { useAtom } from 'jotai'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { downloadPDF, downloadMultiTablePDF } from '../../Reports/analysisReport/pdfAutotable'

const paymentModesWithAll = [
  { id: 0, name: 'All' },
  { id: 1, name: 'Paid' },
  { id: 2, name: 'ToPay' },
]

const toNumber = (value) => Number(value || 0)
const toFixedValue = (value) => Number(toNumber(value).toFixed(2))

const DispatchRegister = (props) => {
  const {
    data: { common, reports },
    getDispatchRegisterReportFilter,
    updateAlertError,
    GetDispatchRegistorMemoTableData,
  } = props

  const { dispatchResisterFilterData } = reports

  const [selDispatchView, setSelDispatchView] = useState(dispatchView[0])
  const [selReportView, setSelReportView] = useState(reportView[0])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [sourceCity, setSourceCity] = useState([])
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceBranch, setSourceBranch] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [destinationCity, setDestinationCity] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationBranch, setDestinationBranch] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [vehicleNoData, setVehicleNoData] = useState([])
  const [selVehicleNo, setSelVehicleNo] = useState('')
  const [paymentType, setPaymentType] = useState(paymentModesWithAll[0])

  const reportName = 'Dispatch Register'
  const reportViewList = [...reportView]

  const [companySettings] = useAtom(companySettingsAtom)
  const [searchParams] = useSearchParams()
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    isFromUrl = true
  }
  const { intCompanyID, intUserID, intBranchID, intBranchCityID, strCompanyName } = loginData

  const headerData = {
    FromDate: moment(fromDate).format('DD-MM-YYYY'),
    ToDate: moment(toDate).format('DD-MM-YYYY'),
    FromCity: selSourceCity?.FromCity,
    FromBranch: selSourceBranch?.FromBranch,
    DispatchView: selDispatchView?.name,
    ToStation: selDestinationCity?.ToCity,
    ToBranch: selDestinationBranch?.DestinationBranch,
    PaymentType: paymentType?.name,
    ReportView: selReportView?.name,
    VehicleNumber: selVehicleNo?.VehicleNo,
  }

  const criteriaHeaders = excelHeader.map((item) => ({
    field: item.field,
    header: item.exportHead,
    textAlign: item.align || 'left',
    xlCol: item.xlCol,
  }))

  const criteriaData = [{ ...headerData, dataType: 'entry' }]

  const getReportMainHeader = (columns, headerKey = 'headerName') =>
    columns.map((column) => ({
      field: column.field || column.dataKey,
      header: column[headerKey] || column.headerName || column.name || column.exportHead,
      exportHead: column.exportHead || column[headerKey] || column.name || column.headerName,
      align: column.align || 'left',
      xlCol: column.xlCol,
      weight: 80,
      isSortIcon: column.isSortIcon,
    }))

  const openViewReport = (reportPayload, isPdf = false) => {
    if (isPdf) {
      if (reportPayload.isMultiTable) {
        // Multi table — StationWise, VehicleWise, Memo
        downloadMultiTablePDF({
          reportName: reportPayload.reportName,
          criteriaHeaders: reportPayload.tables?.[0]?.criteriaHeaders || [],
          criteriaData: reportPayload.tables?.[0]?.criteriaData || [],
          tables: reportPayload.tables.map(table => ({
            reportName: table.reportName,
            tableData: table.tableData,
            visibleColumns: table.mainHeader,
            hideHeader: table.hideHeader || false,
            summaryFields: table.summaryFields,
          })),
          loginData,
        })
      } else {
        // Single table — MemoSummary
        downloadPDF({
          reportName: reportPayload.reportName,
          criteriaHeaders: reportPayload.criteriaHeaders || [],
          criteriaData: reportPayload.criteriaData || [],
          tableData: reportPayload.tableData,
          visibleColumns: reportPayload.mainHeader,
          loginData,
          hideHeader: reportPayload.hideHeader || false,
        })
      }
      return
    }
    const rid = Date.now().toString()
    if (!window.generatedReports) {
      window.generatedReports = {}
    }
    window.generatedReports[rid] = reportPayload
    window.open(`/view-report?rid=${rid}`, '_blank')
  }

  // const formatMemoTableData = (table = []) =>
  //   table.map((item) => ({
  //     ...item,
  //     dataType: 'entry',
  //     Total:
  //       toNumber(item.Freight) +
  //       toNumber(item.F_S_Tax) +
  //       toNumber(item.Cartage) +
  //       toNumber(item.C_S_Tax) +
  //       toNumber(item.Hamali) +
  //       toNumber(item.OptHamali) +
  //       toNumber(item.Total)+
  //       toNumber(item.OptHamaliGST),
  //   }))
  const formatMemoTableData = (table = []) =>
    table.map((item) => {
      const total =
        toNumber(item.Freight) +
        toNumber(item.F_S_Tax) +
        toNumber(item.Cartage) +
        toNumber(item.C_S_Tax) +
        toNumber(item.Hamali) +
        toNumber(item.OptHamali) +
        toNumber(item.OptHamaliGST)
      return {
        ...item,
        dataType: 'entry',
        Total: toFixedValue(total),
      }
    })

  const buildStationSummaryTable = (rows = []) => {
    const summaryRows = rows.map((row) => ({ ...row, Col: ':', dataType: 'entry' }))
    const totals = summaryRows.reduce(
      (acc, row) => ({
        Total_Items: acc.Total_Items + toNumber(row.Total_Items),
        Total_Amount: acc.Total_Amount + toNumber(row.Total_Amount),
      }),
      { Total_Items: 0, Total_Amount: 0 }
    )

    return [
      ...summaryRows,
      {
        PaymentType: 'All Total',
        Total_Items: toFixedValue(totals.Total_Items),
        Total_Amount: toFixedValue(totals.Total_Amount),
        dataType: 'total',
        colSpan: { PaymentType: 1 },
        align: { PaymentType: 'left' },
      },
    ]
  }

  const getDetailedColumns = (columns) =>
    columns.map((column) => {
      if (UseToPayAsCOD === 1 && column.field === 'TO_PAY') {
        return { ...column, headerName: 'COD', exportHead: 'COD' }
      }
      return column
    })

  const getDetailTotalRow = (rows = [], labelField, colSpan) => {
    const totals = rows.reduce(
      (acc, row) => ({
        Qty: acc.Qty + toNumber(row.Qty),
        Freight: acc.Freight + toNumber(row.Freight),
        F_S_Tax: acc.F_S_Tax + toNumber(row.F_S_Tax),
        Cartage: acc.Cartage + toNumber(row.Cartage),
        C_S_Tax: acc.C_S_Tax + toNumber(row.C_S_Tax),
        Hamali: acc.Hamali + toNumber(row.Hamali),
        OperatorHamaliChg: acc.OperatorHamaliChg + toNumber(row.OperatorHamaliChg),
        PAID: acc.PAID + toNumber(row.PAID),
        TO_PAY: acc.TO_PAY + toNumber(row.TO_PAY),
        Total: acc.Total + toNumber(row.Total),
        OptHamaliGST: acc.OptHamaliGST + toNumber(row.OptHamaliGST),
      }),
      {
        Qty: 0,
        Freight: 0,
        F_S_Tax: 0,
        Cartage: 0,
        C_S_Tax: 0,
        Hamali: 0,
        OperatorHamaliChg: 0,
        PAID: 0,
        TO_PAY: 0,
        Total: 0,
        OptHamaliGST: 0,
      }
    )

    return {
      [labelField]: 'Total',
      Qty: toFixedValue(totals.Qty),
      Freight: toFixedValue(totals.Freight),
      F_S_Tax: toFixedValue(totals.F_S_Tax),
      Cartage: toFixedValue(totals.Cartage),
      C_S_Tax: toFixedValue(totals.C_S_Tax),
      Hamali: toFixedValue(totals.Hamali),
      OperatorHamaliChg: toFixedValue(totals.OperatorHamaliChg),
      PAID: toFixedValue(totals.PAID),
      TO_PAY: toFixedValue(totals.TO_PAY),
      Total: toFixedValue(totals.Total),
      OptHamaliGST: toFixedValue(totals.OptHamaliGST),
      dataType: 'total',
      colSpan: { [labelField]: colSpan },
      align: { [labelField]: 'left' },
    }
  }

  const getStationWisePayload = (data = {}) => {
    const detailRows = (data.Table || []).map((row) => ({ ...row, dataType: 'entry' }))
    const summaryRows = data.Table1 || []

    return {
      reportName,
      isMultiTable: true,
      tables: [
        {
          reportName: 'Detailed',
          criteriaHeaders,
          criteriaData,
          mainHeader: getReportMainHeader(getDetailedColumns(PDFHeaderColumnsForStationWise)),
          tableData: [...detailRows, getDetailTotalRow(detailRows, 'Date', 2)],
        },
        {
          reportName: 'Payment Typewise Summary',
          mainHeader: getReportMainHeader(StationWiseSummaryColumn),
          tableData: buildStationSummaryTable(summaryRows),
        },
      ],
    }
  }

  const getVehicleWisePayload = (data = {}) => {
    const detailRows = (data.Table || []).map((row) => ({ ...row, dataType: 'entry' }))
    const summaryRows = data.Table1 || []

    return {
      reportName,
      isMultiTable: true,
      tables: [
        {
          reportName: 'Detailed',
          criteriaHeaders,
          criteriaData,
          mainHeader: getReportMainHeader(getDetailedColumns(PDFHeaderColumnsForVehicleWise)),
          tableData: [...detailRows, getDetailTotalRow(detailRows, 'Date', 3)],
        },
        {
          reportName: 'Payment Typewise Summary',
          mainHeader: getReportMainHeader(VehicleWiseSummaryColumn),
          tableData: buildStationSummaryTable(summaryRows),
        },
      ],
    }
  }

  const getMemoPayload = (firstTable, secondTable, thirdTable) => {
    const buildMemoSummaryFields = (section, fromStation, toStation, amount, toBranch) => [
      { value: section, isSection: true },
      { label: 'From Station', value: fromStation || 'All' },
      { label: 'To Station', value: toStation || 'All' },
      { label: 'Amount', value: amount || 'All' },
      { label: 'To Branch', value: toBranch || 'All' },
    ]

    const summaryRows = [
      { Section: 'Section A Total (+)', TotalAmount: toNumber(firstTable[0]?.Total), dataType: 'entry' },
      { Section: 'Section B Total (+)', TotalAmount: toNumber(secondTable[0]?.Total), dataType: 'entry' },
      { Section: 'Section C Total (-)', TotalAmount: toNumber(thirdTable[0]?.Total), dataType: 'entry' },
      { Section: 'Section B Hamali (-)', TotalAmount: toNumber(secondTable[0]?.Hamali), dataType: 'entry' },
      { Section: 'Section B Fright Comm (-)', TotalAmount: toNumber(secondTable[0]?.FreightCommission), dataType: 'entry' },
      { Section: 'Section B TDS On Comm (+)', TotalAmount: toNumber(secondTable[0]?.TDSOnComm), dataType: 'entry' },
      { Section: 'Section B GST On Comm (+)', TotalAmount: toNumber(secondTable[0]?.GSTOnCommget), dataType: 'entry' },
    ]

    const netAmount =
      summaryRows[0].TotalAmount +
      summaryRows[1].TotalAmount -
      summaryRows[2].TotalAmount -
      summaryRows[3].TotalAmount -
      summaryRows[4].TotalAmount +
      summaryRows[5].TotalAmount +
      summaryRows[6].TotalAmount

    return {
      reportName,
      isMultiTable: true,
      tables: [
        {
          reportName: '',
          criteriaHeaders,
          criteriaData,
          mainHeader: getReportMainHeader(StationWiseMemoCol),
          tableData: firstTable,
          summaryFields: buildMemoSummaryFields(
            'Section A',
            selSourceCity?.FromCity,
            selDestinationCity?.ToCity,
            paymentTypeOptions.find((item) => item.id === 2)?.name || 'ToPay',
            selDestinationBranch?.DestinationBranch
          ),
        },
        {
          reportName: '',
          mainHeader: getReportMainHeader(StationWiseMemoCol),
          tableData: secondTable,
          summaryFields: buildMemoSummaryFields('Section B', 'All', selSourceCity?.FromCity, 'All', 'All'),
        },
        {
          reportName: '',
          mainHeader: getReportMainHeader(StationWiseMemoCol),
          tableData: thirdTable,
          summaryFields: buildMemoSummaryFields(
            'Section C',
            'All',
            selSourceCity?.FromCity,
            paymentTypeOptions.find((item) => item.id === 2)?.name || 'ToPay',
            'All'
          ),
        },
        {
          reportName: 'Summary',
          mainHeader: getReportMainHeader(StationWiseMemoColumn),
          tableData: [
            ...summaryRows.map((row) => ({ ...row, TotalAmount: toFixedValue(row.TotalAmount) })),
            { Section: 'Net Amount', TotalAmount: toFixedValue(netAmount), dataType: 'total',align: 'right' },
          ],
        },
      ],
    }
  }

  const getMemoSummaryPayload = (summaryList = []) => {
    const updatedColumns = memoSummaryHeader.map((column) => {
      if (UseToPayAsCOD === 1 && column.dataKey === 'SectionB') {
        return { ...column, name: 'Section B Total (+)\n COD AMT' }
      }
      return column
    })

    return {
      reportName,
      criteriaHeaders,
      criteriaData,
      mainHeader: getReportMainHeader(updatedColumns, 'name'),
      tableData: summaryList.map((item) => ({ ...item, dataType: 'entry' })),
      serialNokey: 'SN',
    }
  }

  useEffect(() => {
    const uniqueSourceCities = removeDuplicatesFromArray(
      dispatchResisterFilterData?.map((item) => ({ FromCityID: item.FromCityID, FromCity: item.FromCity })) || [],
      'FromCityID'
    )
    const uniqueSourceBranches = removeDuplicatesFromArray(
      dispatchResisterFilterData?.map((item) => ({
        FromBranchID: item.FromBranchID,
        FromBranch: item.FromBranch,
        FromCityID: item.FromCityID,
      })) || [],
      'FromBranchID'
    )
    const uniqueDestinationCities = removeDuplicatesFromArray(
      dispatchResisterFilterData?.map((item) => ({ ToCityID: item.ToCityID, ToCity: item.ToCity, FromCityID: item.FromCityID })) || [],
      'ToCityID'
    )
    const uniqueDestinationBranches = removeDuplicatesFromArray(
      dispatchResisterFilterData?.map((item) => ({
        DestinationBranchID: item.DestinationBranchID,
        DestinationBranch: item.DestinationBranch,
        ToCityID: item.ToCityID,
      })) || [],
      'DestinationBranchID'
    )
    const uniqueVehicles = removeDuplicatesFromArray(
      dispatchResisterFilterData?.map((item) => ({ VehicleID: item.VehicleID, VehicleNo: item.VehicleNo })) || [],
      'VehicleID'
    )

    const defaultSourceCity = uniqueSourceCities.find((item) => item.FromCityID === intBranchCityID)
    const defaultSourceBranch = uniqueSourceBranches.find((item) => item.FromBranchID === intBranchID)

    setSourceCity([{ FromCityID: 0, FromCity: 'All' }, ...uniqueSourceCities])
    setSourceBranch([{ FromBranchID: 0, FromBranch: 'All' }, ...uniqueSourceBranches])
    setDestinationCity([{ ToCityID: 0, ToCity: 'All' }, ...uniqueDestinationCities])
    setDestinationBranch([{ DestinationBranchID: 0, DestinationBranch: 'All' }, ...uniqueDestinationBranches])
    setVehicleNoData(uniqueVehicles)
    setSelVehicleNo(uniqueVehicles[0] || '')
    setSelSourceCity(defaultSourceCity || { FromCityID: 0, FromCity: 'All' })
    setSelSourceBranch(defaultSourceBranch || { FromBranchID: 0, FromBranch: 'All' })
  }, [dispatchResisterFilterData])

  useEffect(() => {
    if (selDispatchView.id === 1 && selReportView.id !== 0) {
      setSelReportView(reportView[0])
    }
  }, [selDispatchView, selReportView])

  const callFilterAPI = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    }

    getDispatchRegisterReportFilter({
      CompanyID: intCompanyID,
      DateFrom: moment(fromDate).format('YYYY-MM-DD'),
      DateTo: moment(toDate).format('YYYY-MM-DD'),
    })

    setSelSourceBranch({ FromBranchID: 0, FromBranch: 'All' })
    setSelDestinationCity({ ToCityID: 0, ToCity: 'All' })
    setSelDestinationBranch({ DestinationBranchID: 0, DestinationBranch: 'All' })
  }

  const selectedSourceCity = (selectedCity) => {
    setSelSourceCity(selectedCity)

    const filteredBranches = removeDuplicatesFromArray(
      dispatchResisterFilterData?.filter(
        (item) => item.FromCityID === selectedCity?.FromCityID || selectedCity?.FromCityID === 0
      )?.map((item) => ({
        FromBranchID: item.FromBranchID,
        FromBranch: item.FromBranch,
        FromCityID: item.FromCityID,
      })) || [],
      'FromBranchID'
    )

    const filteredDestinationCities = removeDuplicatesFromArray(
      dispatchResisterFilterData?.filter(
        (item) => item.FromCityID === selectedCity?.FromCityID || selectedCity?.FromCityID === 0
      )?.map((item) => ({ ToCityID: item.ToCityID, ToCity: item.ToCity, FromCityID: item.FromCityID })) || [],
      'ToCityID'
    )

    setSourceBranch([{ FromBranchID: 0, FromBranch: 'All' }, ...filteredBranches])
    setDestinationCity([{ ToCityID: 0, ToCity: 'All' }, ...filteredDestinationCities])
    setSelSourceBranch({ FromBranchID: 0, FromBranch: 'All' })
  }

  const selectedDestinationCity = (selectedCity) => {
    setSelDestinationCity(selectedCity)

    const filteredBranches = removeDuplicatesFromArray(
      dispatchResisterFilterData?.filter(
        (item) => item.ToCityID === selectedCity?.ToCityID || selectedCity?.ToCityID === 0
      )?.map((item) => ({
        DestinationBranchID: item.DestinationBranchID,
        DestinationBranch: item.DestinationBranch,
        ToCityID: item.ToCityID,
      })) || [],
      'DestinationBranchID'
    )

    setDestinationBranch([{ DestinationBranchID: 0, DestinationBranch: 'All' }, ...filteredBranches])
    setSelDestinationBranch({ DestinationBranchID: 0, DestinationBranch: 'All' })
  }

  const handleClick = async (isPdf = false) => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    }

    if (selReportView.id === 1) {
      const commonMemoParams = {
        intCompanyID: intCompanyID,
        dtFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtTo: moment(toDate).format('YYYY-MM-DD'),
        intUserID: intUserID,
      }

      const [memoFirst, memoSecond, memoThird] = await Promise.all([
        GetDispatchRegistorMemoTableData({
          intFromCityID: selSourceCity?.FromCityID,
          intFromBranchID: selSourceBranch?.FromBranchID,
          intToCityID: selDestinationCity?.ToCityID,
          intToBranchID: selDestinationBranch?.DestinationBranchID,
          intAmountType: 2,
          ...commonMemoParams,
        }),
        GetDispatchRegistorMemoTableData({
          intFromCityID: selDestinationCity?.ToCityID,
          intFromBranchID: selDestinationBranch?.DestinationBranchID,
          intToCityID: selSourceCity?.FromCityID,
          intToBranchID: 0,
          intAmountType: 0,
          ...commonMemoParams,
        }),
        GetDispatchRegistorMemoTableData({
          intFromCityID: selDestinationCity?.ToCityID,
          intFromBranchID: selDestinationBranch?.DestinationBranchID,
          intToCityID: selSourceCity?.FromCityID,
          intToBranchID: 0,
          intAmountType: 2,
          ...commonMemoParams,
        }),
      ])

      if ([memoFirst, memoSecond, memoThird].some((item) => item?.status !== 'Success')) {
        updateAlertError({
          show: true,
          msg: memoFirst?.ErrMessage || memoSecond?.ErrMessage || memoThird?.ErrMessage || 'No Data Found',
          nextId: '',
        })
        return
      }

      const firstTable = formatMemoTableData(memoFirst?.Data?.Table || [])
      const secondTable = formatMemoTableData(memoSecond?.Data?.Table || [])
      const thirdTable = formatMemoTableData(memoThird?.Data?.Table || [])

      if (!firstTable.length && !secondTable.length && !thirdTable.length) {
        updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }

      openViewReport(getMemoPayload(firstTable, secondTable, thirdTable), isPdf)
      return
    }

    if (selReportView.id === 2) {
      const res = await GetRequest(urls.DispatchRegisterMemoSummary + '?', {
        FromCityID: selSourceCity?.FromCityID || 0,
        FromBranchID: selSourceBranch?.FromBranchID || 0,
        ToCityID: selDestinationCity?.ToCityID || 0,
        ToBranchID: selDestinationBranch?.DestinationBranchID || 0,
        CompanyID: intCompanyID,
        DateFrom: moment(fromDate).format('YYYY-MM-DD'),
        DateTo: moment(toDate).format('YYYY-MM-DD'),
        AmountType: 0,
      })

      const summaryTable = res?.Data?.table || res?.Data?.Table || []
      if (res?.status !== 'Success' || !summaryTable.length) {
        updateAlertError({ show: true, msg: res?.ErrMessage || 'No Data Found', nextId: '' })
        return
      }

      const summaryList = summaryTable.map((item, index) => ({
        ...item,
        SN: index + 1,
        NetAmount: toNumber(item.NetAmount),
      }))

      openViewReport(getMemoSummaryPayload(summaryList), isPdf)
      return
    }

    const requestBody = {
      FromCityID: selSourceCity?.FromCityID,
      FromBranchID: selSourceBranch?.FromBranchID,
      ToCityID: selDestinationCity?.ToCityID,
      ToBranchID: selDestinationBranch?.DestinationBranchID,
      CompanyID: intCompanyID,
      dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
      dtToDate: moment(toDate).format('YYYY-MM-DD'),
      AmountType: paymentType?.id,
      ...(selDispatchView.id === 1 ? { VehicleNo: selVehicleNo?.VehicleNo } : {}),
    }

    const res = await GetRequest(urls.DispatchRegisterReport, requestBody)
    if (res?.status !== 'Success') {
      updateAlertError({ show: true, msg: res?.ErrMessage || 'No Data Found', nextId: '' })
      return
    }

    openViewReport(selDispatchView.id === 1 ? getVehicleWisePayload(res?.Data || {}) : getStationWisePayload(res?.Data || {}), isPdf)
  }

  const paymentTypeOptions = paymentModesWithAll
    .map((item) => {
      if (UseToPayAsCOD === 1 && item.id === 2) {
        return { ...item, name: 'COD' }
      }
      return item
    })
    .filter(Boolean)

  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px', ...(!isFromUrl && { background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }) }}>
          {!isFromUrl && <>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id="selectCompnay"
                prevId={'generateDiv'}
                nextId={'ArrowForwardIosIcon1'}
                label={'Company Name'}
                defaultvalue={strCompanyName}
                disabled={true}
                width="100%"
              />
            </Item>
            <Item
              tabIndex={0}
              id="ArrowForwardIosIcon1"
              sx={sx.itemsx}
              className="disabled-wrapper"
              variant="contained"
              disabled={true}
              style={{ ...sx.novp, display: 'flex', justifyContent: 'center', width: '4%', backgroundColor: '#CCC' }}
            >
              <ArrowForwardIosIcon id="ArrowForwardIosIcon1Btn" />
            </Item>
          </>}
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              label={'Dispatch From Date'}
              id="fromDate"
              nextId={'toDate'}
              dateChange={(date) => setFromDate(date)}
              width="100%"
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
            <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
              <Datepicker
                name={'to_dispatch_date'}
                label={'Dispatch To Date'}
                id="toDate"
                nextId={'goButton'}
                prevId={'fromDate'}
                dateChange={(date) => setToDate(date)}
                width="100%"
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button
                variant="contained"
                style={{ ...sx.fullHeight, ...sx.novp }}
                id={'goButton'}
                className="btn btn-primary"
                onClick={callFilterAPI}
              >
                GO
              </Button>
            </Item>
          </Box>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From City'}
              id="dispatchByBranch"
              nextId={'destination'}
              prevId={'goButton'}
              data={sourceCity}
              dataKey={'FromCity'}
              idKey={'FromCityID'}
              defaultvalue={selSourceCity?.FromCity || ''}
              isObjArr={true}
              onSelect={selectedSourceCity}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From Branch'}
              id="destination"
              nextId={'destinationBranch'}
              prevId={'dispatchByBranch'}
              data={sourceBranch || []}
              dataKey={'FromBranch'}
              idKey={'FromBranchID'}
              defaultvalue={selSourceBranch?.FromBranch || ''}
              onSelect={setSelSourceBranch}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch View'}
              id="destinationBranch"
              nextId={selDispatchView.id === 0 ? 'toStation' : 'vehicleList'}
              prevId={'destination'}
              data={dispatchView}
              dataKey={'name'}
              idKey={'id'}
              onSelect={setSelDispatchView}
              defaultvalue={selDispatchView?.name || ''}
              width="100%"
            />
          </Item>
          {selDispatchView.id === 0 ? (
            <>
              <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                <DropDownOA
                  label={'To Station'}
                  id="toStation"
                  defaultvalue={selDestinationCity?.ToCity || ''}
                  data={destinationCity || []}
                  dataKey={'ToCity'}
                  idKey={'ToCityID'}
                  onSelect={selectedDestinationCity}
                  nextId={'toBranch'}
                  prevId={'destinationBranch'}
                  width="100%"
                />
              </Item>
              <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                <DropDownOA
                  label={'To Branch'}
                  id="toBranch"
                  defaultvalue={selDestinationBranch?.DestinationBranch || ''}
                  data={destinationBranch || []}
                  dataKey={'DestinationBranch'}
                  idKey={'DestinationBranchID'}
                  onSelect={setSelDestinationBranch}
                  nextId={'paymentType'}
                  prevId={'toStation'}
                  width="100%"
                />
              </Item>
              <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                <DropDownOA
                  label={'Payment Type'}
                  data={paymentTypeOptions}
                  id="paymentType"
                  nextId={'reportView'}
                  prevId={'toBranch'}
                  defaultvalue={paymentType?.name || ''}
                  width="100%"
                  searchPlaceholder={'Search By Payment Type'}
                  dataKey={'name'}
                  idKey={'id'}
                  onSelect={setPaymentType}
                />
              </Item>
              <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                <DropDownOA
                  label={'Report View'}
                  id="reportView"
                  defaultvalue={selReportView?.name || ''}
                  data={reportViewList}
                  dataKey={'name'}
                  idKey={'id'}
                  onSelect={setSelReportView}
                  nextId={'generateBtn'}
                  prevId={'paymentType'}
                  width="100%"
                />
              </Item>
            </>
          ) : (
            <>
              <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                <DropDownOA
                  label={'Select Vehicle'}
                  id="vehicleList"
                  defaultvalue={selVehicleNo?.VehicleNo || ''}
                  value={selVehicleNo?.VehicleNo || ''}
                  data={vehicleNoData || []}
                  dataKey={'VehicleNo'}
                  idKey={'VehicleID'}
                  onSelect={setSelVehicleNo}
                  nextId={'paymentType'}
                  prevId={'destinationBranch'}
                  width="100%"
                />
              </Item>
              <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                <DropDownOA
                  label={'Payment Type'}
                  data={paymentTypeOptions}
                  id="paymentType"
                  nextId={'generateBtn'}
                  prevId={'vehicleList'}
                  defaultvalue={paymentType?.name || ''}
                  width="100%"
                  searchPlaceholder={'Search By Payment Type'}
                  dataKey={'name'}
                  idKey={'id'}
                  onSelect={setPaymentType}
                />
              </Item>
            </>
          )}
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick(true)} id1={'generateBtn'}>
              DOWNLOAD PDF
            </Button> : <>
              <Item id="generateDiv" tabIndex={0} sx={sx.itemsx}>
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  prevId={'reportView'}
                  id1={'generateBtn'}
                  nextId={'fromDate'}
                  hideToggle={true}
                  onClick1={() => handleClick()}
                  disabled={false}
                />
              </Item>
              <Item sx={{ ...sx.itemsx, display: 'none' }}>
                <RefreshSvg />
              </Item>
            </>}
        </Box>
      </Item>
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateAlertError,
  getDispatchRegisterReportFilter,
  GetDispatchRegistorMemoTableData,
}

export default connect(mapStateToProps, mapDispatchToProps)(DispatchRegister)
